'use client';

import Link from 'next/link';
import Image from 'next/image';
import { ReactNode } from 'react';

type FooterLink = {
  title: string;
  items: {
    title: string;
    href: string;
  }[];
};

type FooterSocial = {
  name: string;
  icon: ReactNode;
  href: string;
};

type FooterProps = {
  links: FooterLink[];
  socials: FooterSocial[];
};

export function Footer({ links, socials }: FooterProps) {
  return (
    <footer className="border-t bg-background">
      <div className="container px-4 py-8 md:py-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {links.map((section) => (
            <div key={section.title} className="space-y-3">
              <h4 className="text-sm font-medium">{section.title}</h4>
              <ul className="space-y-2">
                {section.items.map((link) => (
                  <li key={link.title}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground"
                    >
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-8 flex flex-col items-center justify-between border-t pt-8 md:flex-row">
          <div className="flex items-center gap-2">
            <Image src="/md_logo.svg" alt="Moondream Logo" width={24} height={24} />
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Moondream. All rights reserved.
            </p>
          </div>
          <div className="mt-4 flex gap-4 md:mt-0">
            {socials.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground"
                aria-label={social.name}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}